<template>
  <div
    class="dependentdropdown__title"
    v-bind="$attrs"
    role="heading"
    aria-level="1"
  >
    {{ title }}
  </div>
</template>

<script>
  export default {
    name: 'Heading',
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  };
</script>

<style lang="scss">
.dependentdropdown {
  &__title {
    display: flex;
    font-size: $size-large;
    flex: 1;
    justify-content: center;
  }
}
</style>
